import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 13.032c-3.758 0-6.188 2.023-6.188 5.155 0 1.964 5.154 2.063 6.188 2.063s6.188-.099 6.188-2.063c0-3.132-2.429-5.155-6.188-5.155zM12 10.969c1.99 0 3.609-1.619 3.609-3.609S13.99 3.751 12 3.751 8.391 5.37 8.391 7.36A3.613 3.613 0 0012 10.969z"
}), 'User');